import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
} from '@backstage/core-plugin-api';

import {
  createRootRouteRefsPair,
  createSubRouteRefsPair,
} from '@spotify/confidence-core-react';

export enum RoutesIds {
  collections = 'collections',
  collection = 'collection',
  favorites = 'favorites',
}

enum ExternalRoutesIds {
  metric = 'metric',
  flag = 'flag',
}

// root route
export const [collectionsRouteImplRef, collectionIndexRouteRef] =
  createRootRouteRefsPair({ id: RoutesIds.collections });

export const rootRouteRef = collectionsRouteImplRef;

// sub-routes within the plugin
export const [collectionRouteImplRef, collectionRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.collection,
    parent: rootRouteRef,
    path: '/:id',
  });

// standalone favorites route (outside the collections hierarchy)
export const [favoritesRouteImplRef, favoritesRouteRef] =
  createRootRouteRefsPair({ id: RoutesIds.favorites });

// external routes to other plugins
export const metricRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.metric,
  params: ['id'],
  optional: true,
});

export const flagRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.flag,
  params: ['id'],
  optional: true,
});

// default routes/routes to be used by other plugins
export const Routes = {
  collections: collectionsRouteImplRef,
  collection: collectionRouteImplRef,
  favorites: favoritesRouteImplRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  collections: collectionIndexRouteRef,
  collection: collectionRouteRef,
  favorites: favoritesRouteRef,
  metric: metricRouteRef,
  flag: flagRouteRef,
} satisfies Record<RoutesIds, ExternalRouteRef> &
  Record<ExternalRoutesIds, ExternalRouteRef>;
